export const ItemSectionDivider = () => {
  return <div className="h-[1px] w-full bg-neutral-500" />;
};
